import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { Location } from '@angular/common';


@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(
    private dialog: MatDialog,
    private ngZone: NgZone,
    private location: Location,
  ) { }

  handleError(errorData: Error | HttpErrorResponse): void {
    let deveValidar = true;

    if (errorData instanceof HttpErrorResponse) {
      const urlsToIgnore: string[] = [];

      for (const url of urlsToIgnore) {
        if (errorData.url?.includes(url)) {
          deveValidar = false;
          break;
        }
      }

      if (deveValidar) {
        console.error('Global error captured:', errorData);

        this.ngZone.run(() => {
          let mensagem = "Erro ao processar requisição";

          if (errorData.status === 401) {
            mensagem = "Sessão Expirada. Acesse novamente o sistema";
            this.location.go("home");

          } else {
            if (errorData.error) {

              if (errorData.error.message) {
                mensagem = errorData.error.message;

              } else if (errorData.error.errors) {
                const mensagens = Object.values(errorData.error.errors).join('\n');
                mensagem = mensagens
                  .replace(/\[(.*)\]/g, '$1')
                  .replace(/"/g, '');

              } else if (typeof errorData.error === 'string') {
                mensagem = this.extrairMensagemErro(errorData.error);
              }

              if (errorData.error.ExceptionMessage) {
                mensagem = errorData.error.ExceptionMessage;
              }
            }
          }

          this.dialog.open(InfoDialogComponent, {
            data: {
              titulo: 'Erro',
              mensagem: mensagem
            }
          });
        });
      }

    } else {
      const message = errorData?.message || '';

      if (message.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
        return;
      }

      console.error('Non-HTTP error:', errorData);
    }
  }

  private extrairMensagemErro(erro: string): string {
    if (!erro) return 'Erro inesperado';

    let primeiraLinha = erro.split('\n')[0];

    if (primeiraLinha.includes(':')) {
      primeiraLinha = primeiraLinha.split(':').slice(1).join(':').trim();
    }

    return primeiraLinha;
  }
}
